<template>
    <v-tabs
        class="round-card"
        height="34"
        background-color="background-1"
        slider-color="primary">

        <v-tab key="Configurazione" ripple class="secondary-tab">
            Configurazione
        </v-tab>
        <v-tab key="Template" ripple class="secondary-tab">
            Template
        </v-tab>

        <!-- Tab Configurazione -->
        <v-tab-item class="background-1 pt-3 pb-1" key="Configurazione">
            <whats-app-options></whats-app-options>
        </v-tab-item>

        <!-- Tab Template -->
        <v-tab-item class="background-1 pt-3 pb-1" key="Template">
            <v-row class="ma-0">
                <v-col class="pa-0" cols="12">
                    <crud
                        title='Template WhatsApp'
                        action-icon='mdi-message-text'
                        model-def='templates-whatsapp'
                        action-position='absolute'
                        :default-input="{ type: 'whatsapp' }"
                    ></crud>
                </v-col>
            </v-row>
        </v-tab-item>

    </v-tabs>
</template>

<script>
import WhatsAppOptions from './WhatsAppOptions'

export default {
    name: 'whatsapp-settings',

    components: {
        WhatsAppOptions
    },

    mounted() {
        this.$store.commit('endProgress')
    }
}
</script>